export default __webpack_public_path__ + "static/media/icon-remove-black.1a0e7a83.svg";